import { Link } from 'react-router-dom';

export default function HeroSection() {
  return (
    <section className="relative w-full min-h-[560px] md:min-h-[680px] flex items-center overflow-hidden">
      {/* Background Image */}
      <div className="absolute inset-0">
        <img
          src="https://readdy.ai/api/search-image?query=A%20warm%20atmospheric%20illustration%20of%20a%20cozy%20Japanese%20style%20bookstore%20at%20night%20filled%20with%20manga%20shelves%2C%20soft%20warm%20lighting%20from%20vintage%20lamps%2C%20stacked%20comic%20books%2C%20magical%20floating%20dust%20particles%2C%20dreamy%20aesthetic%2C%20anime%20art%20style%2C%20rich%20orange%20and%20warm%20amber%20tones&width=1920&height=800&seq=hero-manga-bg&orientation=landscape"
          alt="073漫画网 - 在线免费阅读漫画"
          className="w-full h-full object-cover object-top"
        />
        {/* Overlay */}
        <div className="absolute inset-0 bg-gradient-to-b from-black/40 via-black/25 to-background-50"></div>
      </div>

      {/* Content */}
      <div className="relative z-10 w-full px-4 md:px-6">
        <div className="max-w-7xl mx-auto text-center">
          <h1 className="font-heading text-3xl md:text-5xl lg:text-6xl text-background-50 mb-4 leading-tight">
            <span className="block">洞洞杂货铺</span>
            <span className="block text-2xl md:text-3xl lg:text-4xl mt-2 text-accent-400">
              在线免费阅读下拉式漫画
            </span>
          </h1>
          <p className="text-base md:text-lg text-background-200 max-w-2xl mx-auto mb-8 leading-relaxed">
            操作便捷、加载快速，追漫不受限制。汇集<strong>洞洞杂货铺</strong>等海量热门漫画，
            每日更新，支持手机电脑随时畅读，尽在<strong>073漫画网</strong>。
          </p>
          <div className="flex flex-col sm:flex-row items-center justify-center gap-4">
            <Link
              to="/article/1/1"
              className="px-8 py-3 rounded-full bg-primary-500 text-background-50 font-medium text-sm hover:bg-primary-600 transition-colors whitespace-nowrap cursor-pointer"
            >
              开始阅读洞洞杂货铺
            </Link>
            <Link
              to="/category/qihuan"
              className="px-8 py-3 rounded-full bg-background-50/20 backdrop-blur-sm text-background-50 font-medium text-sm border border-background-50/30 hover:bg-background-50/30 transition-colors whitespace-nowrap cursor-pointer"
            >
              浏览更多漫画
            </Link>
          </div>

          {/* Stats */}
          <div className="flex flex-wrap items-center justify-center gap-6 md:gap-10 mt-12">
            {[
              { value: '10,000+', label: '漫画资源' },
              { value: '500万+', label: '月活读者' },
              { value: '每日更新', label: '更新频率' },
              { value: '免费阅读', label: '永久免费' },
            ].map((stat) => (
              <div key={stat.label} className="text-center">
                <div className="text-xl md:text-2xl font-bold text-accent-400 font-heading">
                  {stat.value}
                </div>
                <div className="text-xs md:text-sm text-background-300 mt-1">
                  {stat.label}
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}